var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.radialGauge = function (widget, chart, data, metadata) {
    var container = $('<div class="radial-gauge">').width('90%').height('90%').css({ top: '5%', left: '5%' });
    var kendoFunc = container.kendoRadialGauge;

    MDB.Charts.renderKendoGauge(widget, chart, data, metadata, container, kendoFunc);
};